export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
    access_nivel: [1, 2, 3, 4],
  },
  {
    title: 'Cadastros',
    icon: 'FileTextIcon',
    access_nivel: [1, 3, 4],
    children: [
      {
        title: 'Usuários',
        route: 'list-users',
        access_nivel: [1, 4],
      },
      {
        title: 'Empresas',
        route: 'list-companies',
        access_nivel: [1, 4],
      },
      {
        title: 'Produtos',
        route: 'list-products',
        access_nivel: [1, 3, 4],
      },
      {
        title: 'Tipos',
        route: 'list-types',
        access_nivel: [1, 4],
      },
      {
        title: 'Grãos',
        route: 'list-grains',
        access_nivel: [1, 4],
      },
      {
        title: 'Dimensões',
        route: 'list-dimensions',
        access_nivel: [1, 4],
      },
      {
        title: 'Tabelas de Preço',
        route: 'list-price-tables',
        access_nivel: [1, 4],
      },
      {
        title: 'Fornecedores',
        route: 'SupplierList',
        access_nivel: [1, 2, 4],
      },
      {
        title: 'Vendedores',
        route: 'SalespersonList',
        access_nivel: [1, 4],
      },
    ],
  },
  {
    title: 'Relatórios',
    icon: 'FileIcon',
    access_nivel: [1, 4],
    children: [     
      {
        title: 'Movimentações',
        route: 'list-movements',
        access_nivel: [1, 4],
      }
    ],
  },
  {
    title: 'Clientes',
    route: 'list-clients',
    icon: 'UserIcon',
    access_nivel: [1, 2, 3, 4],
  },
  {
    title: 'Orçamentos',
    route: 'BudgetList',
    icon: 'FileTextIcon',
    access_nivel: [1, 2, 3, 4],
  },

  {
    title: 'Gerar Etiquetas',
    route: 'generate-tags',
    icon: 'TagIcon',
    access_nivel: [1, 2, 4],
  },
  {
    title: 'Estoque',
    route: 'stock',
    icon: 'GridIcon',
    access_nivel: [1, 2, 4],
  },
  {
    title: 'Estoque Manual',
    route: 'manual_stock',
    icon: 'GridIcon',
    access_nivel: [1, 2, 4],
  },
  {
    title: 'Painel de Estoque',
    route: 'PanelProduct',
    icon: 'TvIcon',
    access_nivel: [1, 2, 4],
  },
]
